// extracted by mini-css-extract-plugin
export default {"piece":"ChessPiece_piece__JO34W","selected":"ChessPiece_selected__RlYOT","w":"ChessPiece_w__qUu8u","b":"ChessPiece_b__VUzbA"};